"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseDisclosure = BaseDisclosure;

var _collapse = require("../collapse");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["children", "contentSize", "disabled", "header", "isOpen", "scrollOnOpen", "size", "toggle"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * `Wrapper` styled component.
 */
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "base-disclosure__Wrapper",
  componentId: "sc-16umh99-0"
})(["background-color:", ";border:1px solid ", ";border-radius:", "px;transition:opacity ", ";", ""], (0, _styles.color)('white'), (0, _styles.color)('gray200'), (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["opacity:0.5;"])));
/**
 * `Header` styled component.
 */


var Header = _styledComponents["default"].button.withConfig({
  displayName: "base-disclosure__Header",
  componentId: "sc-16umh99-1"
})(["appearance:none;background:transparent;border:0;color:inherit;cursor:pointer;text-align:inherit;width:100%;", " ", " &:disabled{cursor:default;pointer-events:none;}"], (0, _styledTools.switchProp)('size', {
  medium: (0, _styledComponents.css)(["padding:16px;", ""], _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        padding: 24px;\n      "])))),
  small: (0, _styledComponents.css)(["padding:12px;", ""], _styles.media.min('md')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        padding: 16px;\n      "]))))
}), _styles.states.action(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    outline: none;\n  "]))));
/**
 * `Content` styled component.
 */


var Content = _styledComponents["default"].div.withConfig({
  displayName: "base-disclosure__Content",
  componentId: "sc-16umh99-2"
})(["", ""], (0, _styledTools.switchProp)('size', {
  extraSmall: (0, _styledComponents.css)(["padding:0 12px 12px;", ""], _styles.media.min('md')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["  \n        padding: 16px;\n      "])))),
  medium: (0, _styledComponents.css)(["padding:0 16px 16px;", ""], _styles.media.min('md')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["  \n        padding: 6px 24px 24px;\n      "])))),
  small: (0, _styledComponents.css)(["padding:0 12px 24px;", ""], _styles.media.min('md')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["  \n        padding: 24px 16px;\n      "]))))
}));
/**
 * Export `BaseDisclosure` component.
 */


function BaseDisclosure(props) {
  var children = props.children,
      _props$contentSize = props.contentSize,
      contentSize = _props$contentSize === void 0 ? 'medium' : _props$contentSize,
      disabled = props.disabled,
      header = props.header,
      isOpen = props.isOpen,
      scrollOnOpen = props.scrollOnOpen,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      toggle = props.toggle,
      rest = _objectWithoutProperties(props, _excluded);

  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!scrollOnOpen || !isOpen) {
      return;
    }

    var timeout = setTimeout(function () {
      if (ref.current && ref.current.scrollIntoView) {
        ref.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, 300);
    return function () {
      return clearTimeout(timeout);
    };
  }, [isOpen, scrollOnOpen]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({
    disabled: disabled,
    ref: ref
  }, rest), /*#__PURE__*/_react["default"].createElement(Header, {
    "aria-expanded": isOpen,
    disabled: disabled,
    onClick: toggle,
    size: size,
    type: 'button'
  }, header), children && /*#__PURE__*/_react["default"].createElement(_collapse.Collapse, {
    isOpen: isOpen
  }, /*#__PURE__*/_react["default"].createElement(Content, {
    size: contentSize
  }, children)));
}